module.exports = __webpack_public_path__ + "img/limaojin.67dbb9a6.jpg";